import { MDBContainer } from "mdb-react-ui-kit";
import React , { useState } from "react";
import DashboardSidebar from "../component/sidenav";
import { Outlet } from "react-router-dom"
const Dashboard = () => {
    const [didToggle, setDidToggle] = useState(
        window.innerWidth > 768 ? false : true
    );

    let link = [
        {
            name: "Dashboard",
            path:"/dashboard/admin",
            icon: "home",
            children: [],
        },
        {
            name: "Disaster",
            path:"",
            icon: "cloud-showers-heavy",
            children: [
                {
                    name: "Typhoon",
                    path: "/dashboard/typhoon",
                    icon: "home",
                    children:[]
                },
                {
                    name: "Earthquake",
                    path: "/dashboard/earthquake",
                    icon: "home",
                    children:[]
                }
            ]
        },
        {
            name: "Settings",
            path:"/dashboard/settings",
            icon: "cog",
            children:[]
        },
    ]

    return (
        <MDBContainer>
        <DashboardSidebar 
        links={link} 
        didToggle={didToggle}
        setDidToggle={setDidToggle}
        />
        <main
        className="main-container"
        style={{
          paddingLeft:
            window.innerWidth > 768
              ? didToggle 
                ? window.innerWidth <= 768
                  ? "0rem"
                  : "4.5rem"
                : "17.5rem"
              : "0rem",
        }}
        >
        <MDBContainer fluid className="px-0">
        <Outlet />        
        </MDBContainer>
        </main> 
        </MDBContainer>
    )
}

export default Dashboard;